// apps/web/src/components/AppInitializer.tsx
import LoadingInline from "./LoadingInline";
import { useUserContext } from "../contexts/UserContext";

export default function AppInitializer({
    children,
}: {
    children: React.ReactNode;
}) {
    const user = useUserContext();

    // ✅ Auth + User + Company 判定が全部終わるまで
    if (user.loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingInline />
            </div>
        );
    }

    return <>{children}</>;
}
